import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { useMemo } from 'react';

export function useIsFinancialInfoEmpty() {
  const { api } = useCompanyReadDataContext();
  return useMemo(
    () =>
      !api?.data?.financial?.revenue?.annual?.amount &&
      !api?.data?.financial?.ipo?.valuation &&
      !api?.data?.financial?.ipo?.link?.label &&
      !api?.data?.financial?.funding?.total_amount,
    [
      api?.data?.financial?.revenue?.annual?.amount,
      api?.data?.financial?.ipo?.valuation,
      api?.data?.financial?.ipo?.link?.label,
      api?.data?.financial?.funding?.total_amount,
    ]
  );
}
